<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="term.id === null">{{ 'term.NEWterm' | translate }}</span>
            <span *ngIf="term.id !== null">{{ 'term.EDITterm' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="termForm" id="termForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="termForm" >
            <input type="hidden" name="id" id="termId" formControlName="id" />
         
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-newspaper"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="application" [autoDisplayFirst]="false" formControlName="application" [options]="applications" (onChange)="onChange($event)" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="application" class="req">{{ 'application' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="termForm.controls['application'].invalid && (termForm.controls['application'].dirty || termForm.controls['application'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="termForm.controls['application'].errors !== null">
                  <div *ngIf="termForm.controls['application'].errors.required">
                   {{ 'term.termTYPEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            
            </div><!--/p-fluid p-grid-->
          
            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                  <label for="content" class="req">{{ 'DESCRIPTION' | translate }}</label>
                  <ckeditor  inputId="content" formControlName="content"  [editor]="Editor" [config]="editorService.config" type="content"  [required]="true" ></ckeditor>
                </div>
                <div *ngIf="termForm.controls['content'].invalid && (termForm.controls['content'].dirty || termForm.controls['content'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="termForm.controls['content'].errors !== null">
                  <div *ngIf="termForm.controls['content'].errors.required">
                   {{ 'DESCRIPTION' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            
            </div><!--/p-fluid p-grid-->
          
         

            <div class="p-fluid p-grid">

              <div class="p-col-12">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!postForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'ACTIONS.SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

